const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/ui.tsx';
import _ from 'lodash';
import { Divider } from '@mui/material';
import { ReactElement } from 'react';

export const addDividers = (elements: ReactElement<any>[], className: string = 'divider'): ReactElement<any>[] => {
    return _.compact(elements).reduce((accumulator: ReactElement<any>[], element, index) => {
        if (index > 0) accumulator.push(<Divider key={`divider_${index}`} className={className} />);
        accumulator.push(element);
        return accumulator;
    }, []);
};
